'use client';

import * as React from 'react';

export interface AppShellFrameProps {
	/** Fascia di avviso opzionale sopra l'header. */
	banner?: React.ReactNode;
	/** Header dell'app (tipicamente {@link AppHeader}). */
	header: React.ReactNode;
	/** Sidebar di navigazione. */
	sidebar: React.ReactNode;
	/** Contenuto della pagina corrente, renderizzato nell'area scrollabile principale. */
	children: React.ReactNode;
	/** Modal e altri portali montati a livello di shell (sopra tutto il resto). */
	overlays?: React.ReactNode;
}

/**
 * Struttura globale (chrome) dell'app autenticata: banner, header, sidebar e area
 * principale scrollabile. Condivisa da SLIMS CER e SLIMS PRO — cambia solo il
 * contenuto degli slot e la tinta d'accento. Possiede l'intero scrolling della
 * shell: le pagine figlie non devono gestire il proprio scroll.
 *
 * Sotto l'header non c'è nessuna barra di contesto: come nel mock `SLIMS-CER_v11.html`,
 * il contenuto della pagina attacca direttamente all'header in entrambe le interfacce.
 */
const AppShellFrame = ({ banner, header, sidebar, children, overlays }: AppShellFrameProps) => {
	return (
		<div className="flex h-screen flex-col overflow-hidden bg-bg">
			{banner}
			{header}
			<div className="relative z-[1] flex min-h-0 flex-1 overflow-hidden">
				{sidebar}
				<main className="min-h-0 flex-1 overflow-y-auto p-5 animate-fade-in">{children}</main>
			</div>
			{overlays}
		</div>
	);
};
AppShellFrame.displayName = 'AppShellFrame';

export { AppShellFrame };
